export default __webpack_public_path__ + "static/media/lab5.e5dda7ad.jpg";